import { render, staticRenderFns } from "./AuthForm.vue?vue&type=template&id=34054664&"
import script from "./AuthForm.vue?vue&type=script&lang=ts&"
export * from "./AuthForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports